var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoRolesLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 80,
    viewBox: "0 0 60 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.5552 63.314L59.2831 62.259L7.1016 30.2637L5.37378 31.322L57.5552 63.314Z",
    fill: "url(#paint0_linear_40_294685)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2832 78.9447V62.2588L57.5554 63.3138V79.9997L59.2832 78.9447Z",
    fill: "url(#paint1_linear_40_294685)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5552 80.0002L5.37378 48.0048V31.3223L57.5552 63.3142V80.0002Z",
    fill: "url(#paint2_linear_40_294685)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.675 48.4036C14.7254 48.5041 14.7853 48.5911 14.8452 48.6749C14.9682 48.8591 15.1132 49.0064 15.2583 49.0935C15.438 49.204 15.6146 49.2308 15.7533 49.1471L19.4044 46.95C19.6819 46.7825 19.6819 46.24 19.4107 45.7342C19.1364 45.2285 18.6918 44.9539 18.4175 45.118L15.2772 47.0069L14.2367 44.9539C13.9782 44.4414 13.5304 44.14 13.2435 44.2807C12.9535 44.4213 12.9314 44.9539 13.1931 45.4663L14.6813 48.4002L14.675 48.4036Z",
    fill: "#8B8B8B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0927 65.896L25.0671 51.166C24.6793 50.9282 24.364 51.1225 24.364 51.5981C24.364 52.0736 24.6793 52.6531 25.0671 52.8909L49.0927 67.6208C49.4805 67.8586 49.7958 67.6644 49.7958 67.1888C49.7958 66.7132 49.4805 66.1338 49.0927 65.896Z",
    fill: "#8B8B8B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5616 33.0503L59.2894 31.992L7.10795 0L5.38013 1.05501L57.5616 33.0503Z",
    fill: "url(#paint3_linear_40_294685)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2862 48.6781L59.2893 31.9922L57.5615 33.0505L57.5583 49.7365L59.2862 48.6781Z",
    fill: "url(#paint4_linear_40_294685)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5584 49.7359L5.37695 17.7406L5.38011 1.05469L57.5616 33.05L57.5584 49.7359Z",
    fill: "url(#paint5_linear_40_294685)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6813 18.1399C14.7318 18.2404 14.7917 18.3275 14.8516 18.4112C14.9745 18.5954 15.1196 18.7428 15.2646 18.8298C15.4443 18.9404 15.6209 18.9672 15.7596 18.8834L19.4108 16.6863C19.6882 16.5189 19.6882 15.9763 19.4171 15.4706C19.1428 14.9648 18.6982 14.6902 18.4239 14.8543L15.2835 16.7433L14.2431 14.6902C13.9845 14.1777 13.5368 13.8763 13.2499 14.017C12.9598 14.1577 12.9377 14.6902 13.1994 15.2026L14.6876 18.1366L14.6813 18.1399Z",
    fill: "#8B8B8B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0958 35.6294L25.0703 20.8994C24.6825 20.6616 24.3672 20.8559 24.3672 21.3315C24.3672 21.807 24.6825 22.3865 25.0703 22.6243L49.0958 37.3542C49.4836 37.592 49.7989 37.3978 49.7989 36.9222C49.7989 36.4466 49.4836 35.8672 49.0958 35.6294Z",
    fill: "#8B8B8B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5894 46.1226L54.3172 45.0642L2.13578 13.0723L0.407959 14.1273L52.5894 46.1226Z",
    fill: "url(#paint6_linear_40_294685)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.314 61.7504L54.3172 45.0645L52.5893 46.1228L52.5862 62.8054L54.314 61.7504Z",
    fill: "url(#paint7_linear_40_294685)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5862 62.7242L0.404785 30.7289L0.407939 14.043L52.5894 46.0383L52.5862 62.7242Z",
    fill: "url(#paint8_linear_40_294685)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70915 31.1282C9.7596 31.2287 9.8195 31.3157 9.87941 31.3995C10.0024 31.5837 10.1474 31.731 10.2924 31.8181C10.4722 31.9287 10.6487 31.9554 10.7875 31.8717L14.4386 29.6746C14.716 29.5071 14.716 28.9646 14.4449 28.4588C14.1706 27.9531 13.726 27.6785 13.4517 27.8426L10.3114 29.7315L9.27089 27.6785C9.01234 27.166 8.56463 26.8646 8.27771 27.0053C7.98764 27.1459 7.96556 27.6785 8.22726 28.1909L9.71546 31.1248L9.70915 31.1282Z",
    fill: "#8B8B8B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1237 48.6177L20.0981 33.8877C19.7103 33.6499 19.395 33.8441 19.395 34.3197C19.395 34.7953 19.7103 35.3747 20.0981 35.6125L44.1237 50.3425C44.5115 50.5803 44.8268 50.3861 44.8268 49.9105C44.8268 49.4349 44.5115 48.8554 44.1237 48.6177Z",
    fill: "#8B8B8B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0.407959 14.043L52.5894 46.0383",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.38013 1.05469L57.5616 33.05",
    stroke: "#F3F3F3",
    strokeWidth: 0.75
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_40_294685",
    x1: 31.8965,
    y1: 47.586,
    x2: 32.8444,
    y2: 46.0413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_40_294685",
    x1: 57.5554,
    y1: 71.1276,
    x2: 59.2832,
    y2: 71.1276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4A4A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_40_294685",
    x1: 5.37378,
    y1: 55.6612,
    x2: 57.5552,
    y2: 55.6612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4A4A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_40_294685",
    x1: 31.8997,
    y1: 17.3223,
    x2: 32.8476,
    y2: 15.7777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_40_294685",
    x1: 57.5583,
    y1: 40.8643,
    x2: 59.2893,
    y2: 40.8643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4A4A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_40_294685",
    x1: 5.37695,
    y1: 25.397,
    x2: 57.5616,
    y2: 25.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4A4A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_40_294685",
    x1: 26.9275,
    y1: 30.3912,
    x2: 27.8753,
    y2: 28.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_40_294685",
    x1: 52.5862,
    y1: 53.9366,
    x2: 54.3172,
    y2: 53.9366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A4A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_40_294685",
    x1: 0.404785,
    y1: 38.3819,
    x2: 52.5894,
    y2: 38.3819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFBEBE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRolesLarge);
export default __webpack_public_path__ + "static/media/no_roles_large.372dd857b33a47d98355606117f393c4.svg";
export { ForwardRef as ReactComponent };